<div class="st-mos-full-screen">
    <st-combo-box
        st-click-stop-propagation
        label="MOS Plug-in"
        [addEmptyOption]="false"
        [value]="mosDeviceValue()"
        [itemList]="mosItemList()"
        (changed)="onMosChange($event)" />
    @if (mosUrl()?.length > 0) {
        <div
            #mosIframeOverlay
            class="st-mos-full-screen-iframe-overlay">
            <iframe
                #mosIframe
                width="100%"
                height="100%"
                frameborder="0"
                allowfullscreen
                scrolling="yes"
                [src]="mosUrl() | unsafe: 'resourceUrl'"
                (load)="onMosLoad()"></iframe>
        </div>
    }
</div>
